export const SUPERB_EQUIPMENT_CODE = 'SUPB' as const

export function withSuperbEquipment<T extends string>(
  types: readonly T[],
  enabled: boolean
): Array<T | typeof SUPERB_EQUIPMENT_CODE> {
  const withoutSuperb = types.filter(type => type !== SUPERB_EQUIPMENT_CODE)

  return enabled ? [...withoutSuperb, SUPERB_EQUIPMENT_CODE] : withoutSuperb
}

export function withSuperbEquipmentItems<T extends { value: string }>(
  items: readonly T[],
  enabled: boolean
): T[] {
  return items.filter(item => item.value !== SUPERB_EQUIPMENT_CODE || enabled)
}
